function disableBodyScroll() {
  const position = document.documentElement.scrollTop;
  const body = document.querySelector("body");
  if (!body) return;

  body.style.top = "absolute"
  body.style.overflow = "hidden"
  body.style.position = `-${position}px`
}

function enableBodyScroll() {
  const body = document.querySelector("body");
  if (!body) return;

  body.style.removeProperty("overflow");
  body.style.removeProperty("position");
  body.style.removeProperty("top");
}

export {
  disableBodyScroll,
  enableBodyScroll 
}
